import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LoadingStoreModule } from './loading-store/loading-store.module';
import { ErrorStoreModule } from './error-store/error-store.module';
import { AuthStoreModule } from './auth-store/auth-store.module';
import { UserStoreModule } from './user-store/user-store.module';

@NgModule({
    declarations: [],
    imports: [
        AuthStoreModule,
        UserStoreModule,

        ErrorStoreModule,
        LoadingStoreModule,
        // Feature store modules should be imported before this:
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),

        // StoreDevtoolsModule.instrument({
        //     maxAge: 25,
        // }),
    ],
})
export class RootStoreModule {}
